import { render, staticRenderFns } from "./AverageBasket.vue?vue&type=template&id=25a87b24&scoped=true&"
import script from "./AverageBasket.vue?vue&type=script&lang=js&"
export * from "./AverageBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a87b24",
  null
  
)

export default component.exports